import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { DrawerService } from '@cardapio-online/drawer';
import { CartItem } from '../../../cart/cart.models';
import { CartService } from '../../../cart/cart.service';

@Component({
  selector: 'lib-ui-cart',
  templateUrl: './ui-cart.component.html',
  styleUrl: './ui-cart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCartComponent {
  protected readonly cart = inject(CartService);
  private readonly router = inject(Router);
  private readonly drawer = inject(DrawerService);

  protected itemTotal(item: CartItem): number {
    const extras = item.adicionais.reduce((a, x) => a + x.price, 0);
    return (item.unitPrice + extras) * item.quantity;
  }

  protected increment(productId: string): void {
    const item = this.cart.items().find((i) => i.productId === productId);
    if (item) this.cart.updateQuantity(productId, item.quantity + 1);
  }

  protected decrement(productId: string): void {
    const item = this.cart.items().find((i) => i.productId === productId);
    if (item) this.cart.updateQuantity(productId, item.quantity - 1);
  }

  protected goToCheckout(): void {
    this.drawer.close();
    this.router.navigate(['/checkout']);
  }
}
